const extractBackendMessage = (err: unknown): string => {
    const body = (err as { body?: Record<string, unknown> }).body;
    const bodyMessage = body && (body['message'] ?? body['Message']);
    if (typeof bodyMessage === 'string') {
        return bodyMessage;
    }
    return err instanceof Error ? err.message : String(err);
};

export const toFriendlyUserErrorMessage = (err: unknown): string => {
    const message = extractBackendMessage(err);

    if (message.includes('users in their own institution')) {
        return 'You can only add users from your own institution.';
    }
    if (message.includes('can create other admins')) {
        return 'Only an administrator can create another admin user.';
    }
    if (message.includes('create other course instructors')) {
        return 'Only an administrator or course instructor can create another course instructor.';
    }
    return 'There was a problem saving the user. Please double-check the details and try again. If this keeps happening, please contact the site administrator.';
};